const validate = {
  rules: {
    nome: {
      required: true,
    },
  },
  messages: {
    nome: "O nome é obrigatório.",
  },
};

export default validate;
